<template>
  <div :id="uuid" :style="{ width: width + 'px', height: height + 'px' }" />
</template>

<script setup>
import { getDataJson, pollingRefresh, hasNonEmptyValues, hasProperty } from "@/utils/refresh-cpt-data";
import { onMounted, watch, computed } from "vue";
import * as echarts from 'echarts'

const props = defineProps({
  width: Number,
  height: Number,
  option: Object,
  show: Boolean,
  components: Array,
  current: Object
})
// 新增属性兼容旧代码
const attr = props.option.attribute
if (!attr.globalDataReload) attr.globalDataReload = [0]

let dataReload = computed(() => props.option.attribute.globalDataReload || [0])
watch(() => props.current.cptShow,(val)=>{
    if (val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
  watch(() => props.option.attribute.hideCompInTabw,(val)=>{
    if (!val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
watch(() => props.option.attribute, (obj) => {
  if (obj.dataZoom && obj.dataZoom.show) {
    obj.grid.y2 = obj.grid.y2 == 30 ? 50 : obj.grid.y2;
  } else {
    obj.grid.y2 = obj.grid.y2 == 50 && obj.grid.y2 != 30 ? 30 : obj.grid.y2;
  }
  processData(props.option.cptDataForm, newData, jsFunFlag)
  loadChart(obj);
}, { deep: true })
watch(() => [props.width, props.height], () => {
  chart.resize()
})

let uuid = require('uuid').v1();
let chartOption = {};
let chart = null
let cptData = [];
let newData = "";
let jsFunFlag = false;
const emit = defineEmits(['clickHandler'])

onMounted(() => {
  const element = document.getElementById(uuid)
  if (!element) return
  chart = echarts.init(element)
  if (dataReload.value.includes(0)) {
    refreshCptData();
  }
})

function refreshCptData(cptDataForm = props.option.cptDataForm, paras) {
  pollingRefresh(uuid, cptDataForm, () => loadData(cptDataForm, paras),
    props.components)
}
function loadData(cptDataForm, paras) {
  getDataJson(cptDataForm, paras, (res) => {
    // cptData = res;
    newData = cptDataForm.dataSource == '4' && hasProperty(res, 'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
    jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res, 'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
    processData(cptDataForm, newData, jsFunFlag)
    loadChart(props.option.attribute);

  })
}
function processData(cptDataForm, res, jsFunFlag) {
  // 第一层判断 如果选择数据集
  if (cptDataForm.dataSource == '4') {
    // 第二层判断 ，如果没有配转换脚本
    if (jsFunFlag) { // 没有全部配置映射字段
      if (hasNonEmptyValues(props.option.attribute.cptTableData)) {
        const dataKey = props.option.attribute.cptTableData;
        // 创建键值映射对象
        const dataKeyMap = dataKey.reduce((acc, curr) => {
          acc[curr.namekey] = curr.value;
          return acc;
        }, {});

        // 初始化新数组
        let newarr = [];
        let groupData = {};

        // 遍历原始数组进行转换
        res.forEach(item => {
          const group = item[dataKeyMap.group];
          const values = item[dataKeyMap.value].split(',');

          if (!groupData[group]) {
            groupData[group] = { group, data: [] };
          }

          groupData[group].data.push(values.slice(0, -1).map(Number).concat([values[values.length - 1]]));
        });

        // 将分组数据对象转换为新数组形式
        for (const group in groupData) {
          newarr.push(groupData[group]);
        }

        console.log(newarr, '新数组')

        cptData = newarr;
      }
    } else { // 如果配置了转换脚本
      cptData = res;
    }
  } else { // 不是数据集类型，是静态数据
    cptData = res;
  }
}
function loadChart(attr) {
  const attrBackup = JSON.parse(JSON.stringify(attr));//Object.assign会导致原对象被修改
  let series = [];
  cptData.forEach(item => {
    series.push({
      name: item.group,
      data: item.data,
      type: 'scatter',
      symbolSize: function (data) {
        return data[2] * attr.scale;
      },
      emphasis: {
        focus: 'series',
        label: {
          show: true,
          formatter: function (param) {
            return param.data[3];
          },
          position: 'top'
        }
      }
    });
  })
  chartOption = Object.assign(attrBackup, {
    tooltip: {
      show: true,
      formatter: function (params) {
        return params.seriesName + "-" + params.data[3] + attr.xTip + params.data[0] + attr.yTip + params.data[1] + attr.areaTip + params.data[2];
      },
      ...attr.tooltip
    },
    series: series,
    dataZoom: attr.dataZoom,
    grid: Object.assign(attr.grid, { containLabel: true }),
  })
  chart.setOption(chartOption, true);
  chart.on('click', (params) => {
    emit("clickHandler", props.option.interaction, 'default', params.name)
  })
}

defineExpose({ refreshCptData })
</script>

<style scoped></style>
